<template>
    <div v-if="cultureIsLoaded" class="outline-none" tabindex="0" @keydown.esc="onEscapeDown">
  
      <!-- Buttons -->
      <div>
        <!-- Events-->
        <button :disabled="true" class="btn btn--primary relative">
          <span>{{ $t('pages.culture_show.events') }}</span>
          <span v-if="culture.nbPendingEvents > 0" class="badge -top-2.5 -right-2.5 ml-2">{{ culture.nbPendingEvents }}</span>
        </button>
  
        <!-- CSV download-->
        <button :disabled="true" class="ml-4 btn btn--primary relative">
          <i class="fas fa-download mr-2"></i> CSV
        </button>
  
        <!-- Close -->
        <button :disabled="true" class="ml-4 btn btn--danger"><i class="mr-2 fas fa-power-off"></i>{{ $t('pages.culture_show.close_btn') }}</button>
        <p class="text-gray-500 text-sm">
          <span>{{ $t('pages.visitor.warning') }}</span>
        </p>
      </div>
  
      <!-- Card details -->
      <div class="card-container mt-4">
        <div class="flex">
          <!-- Details-->
          <div>
            <h2 class="card__title">{{ $t('pages.culture_show.cards.details.title') }} <span class="font-semibold">"{{ culture.name }}"</span></h2>
            <div>
              <div class="flex justify-items-start">
                <div>
                  <div><i class="fas fa-leaf mr-2" style="color: gray;"></i>{{ $t('pages.culture_show.cards.details.cultivatedVariety') }}: </div>       
                  <div><i class="fas fa-seedling mr-2" style="color: gray;"></i>{{ $t('pages.culture_show.cards.details.cultureType') }}: </div>
                  <div><i class="fas fa-calendar-alt mr-2" style="color: gray;"></i>{{ $t('pages.culture_show.cards.details.nouaisonDate') }}: </div>
                </div>
  
                <div class="ml-4 font-semibold">
                  <div>{{ this.$t('backend_trans_keys.'+culture.typeTransKey) + " " + this.$t('backend_trans_keys.'+culture.varietyTransKey) }}</div>
                  <div>{{ culture.outside ? this.$t('words.outside') : this.$t('words.inside') }}</div>
                  <div>{{ culture.nouaisonDate === null ? '-' : this.displayDate(culture.nouaisonDate) }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- Map displaying (geographic or custom) -->
          <div v-if="culture.hasGeoMap !== null" class="map-wrapper">
            <img v-if="culture.hasGeoMap === false" :src="apiUploadMapsRoute + '/' + culture.mapImageName">
            <img class="rounded-md" v-else src="../../../assets/images/real_maps_overlay.png" alt="">
            <div class="map-btn">{{ $t('pages.culture_show.cards.details.showMap') }}</div>
          </div>
        </div>
      </div>
  
      <!-- Card transmitters -->
      <div class="card-container mt-4">
        <h2 class="card__title">{{ $t('pages.culture_show.cards.transmitters.title', {"count": transmittersTable.data.length}) }}</h2>
        <data-table :columns="transmittersTable.columns" :data="transmittersTable.data" />
      </div>
    </div>
  </template>
  
  <script>
  import DataTable from "../../../components/general/datatable/data-table";
  import {
    apiGetRequest,
    displayDateByLocale,
    displayDateTimestampByLocale,
    displayElapsedTimeToTimestamp
  } from "../../../utils";
  import {
    VISITOR_SHOW,
    API_UPLOAD_MAPS_ROUTE,
  } from "../../../utils/constants";
  
  export default {
    name: "VisitorShow",
    components: {DataTable},
    props: {},
    data: function() {
      return {
        id: this.$route.params.id,
        cultureIsLoaded: false,
        culture : {},
        transmittersTable: {
          columns: {
            id: this.$t('words.id'),
            type: this.$t('words.type'),
            batteryLevel: this.$t('words.battery-level'),
            nbSensors: this.$t('words.nbSensors'),
            lastSeenAtElapsed: this.$t('words.active-last-time'),
            lastMeasureAtElapsed: this.$t('words.last-measure-at'),
            actions: this.$t('words.actions')
          },
          data: null,
        },
        loadingCSV: false,
        
        apiUploadMapsRoute: API_UPLOAD_MAPS_ROUTE,
      }
    },
    mounted() {
      this.loadCulture()
    },
    computed: {
      displayableTransmitters: function() {
        return this.culture.transmitters.filter(t => t.latitude !== null && t.longitude !== null)
      },
    },
    methods: {
  
      /**
       * Load culture info
       */
      loadCulture: function() {
        this.cultureIsLoaded = false
  
        // Fetch all culture info
        apiGetRequest(VISITOR_SHOW)
            .then((res) => {
              this.culture = res.data
              this.transmittersTable.data = this.culture.transmitters.map((t) => {
                let lastBatteryAt = t.lastBatteryAt === null ? "" : "(" + this.displayDateTimeByTimestamp(t.lastBatteryAt) + ")"
                t.type = this.$t('backend_trans_keys.'+t.typeTransKey)
                t.batteryLevel = t.batteryPct == null ? this.$t('words.unknown') : t.batteryPct + " % " + lastBatteryAt
                t.lastSeenAtElapsed = t.lastSeenAt == null ? this.$t('words.never') : displayElapsedTimeToTimestamp(t.lastSeenAt)
                t.lastMeasureAtElapsed = t.lastMeasureAt == null ? this.$t('words.never') : displayElapsedTimeToTimestamp(t.lastMeasureAt)
                t.actions = {
                  see: {
                    to: t.typeTransKey == "transmitterType_simple" ? "VisitorNode" : "VisitorWeather",
                    text: this.$t('words.see')
                  }
                }
                return t
              })
  
              this.cultureIsLoaded = true
            })
      },
      

      /**
       * Display date by timestamp using moment.js locale
       * @param dateTimeTimestamp The date to display in timestamp
       * @returns {string} A string representation of the date, well formatted by the current locale
       */
      displayDateTimeByTimestamp: function(dateTimeTimestamp) {
        return displayDateTimestampByLocale(dateTimeTimestamp)
      },
      /**
       * Display date by moment.js locale
       * @param date The date to display
       * @returns {string} A strig representation of the date, well formatted by the current locale
       */
      displayDate: function(date) {
        return displayDateByLocale(date, true)
      },
    }
  }
  </script>
  
  <style scoped>
  
  
  .btn:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  .map-wrapper{
    @apply overflow-hidden relative ml-10 w-44 flex items-center cursor-pointer p-1 rounded-md;
  }
  .map-wrapper .map-btn {
    @apply absolute top-0 right-0 bg-blue-500 px-2 py-1 text-sm rounded-md text-white border-l border-b border-blue-600 font-semibold;
  }
  .map-wrapper:hover > .map-btn {
    @apply bg-blue-600;
  }
  .map-wrapper img{
    transition: transform .5s ease;
  }
  .map-wrapper:hover img {
    transform: scale(1.5);
  }
  
  /* Card details and transmitters */
  .card {
    background-color: #f2f2f2; /* Gris clair */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 0.5rem; /* Coins arrondis */
    padding: 1rem;
  }
  
  /* Modal and other sections */
  .bg-gray-200 {
    background-color: #e2e8f0; /* Gris clair */
  }
  
  .shadow-md {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .rounded-lg {
    border-radius: 0.5rem;
  }
  
  /* Encadré léger avec ombre et coins arrondis */
  .card-container {
    border: 1px solid rgba(0, 0, 0, 0.1); /* Bordure légère */
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 12px; /* Coins arrondis */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Ombre légère */
    background-color: #ffffff; /* Fond blanc pour plus de clarté */
    overflow: auto; /* Gestion de débordement */
  }
  
  /* Styles pour les contrôles de la carte */
  .map-control {
    background-color: #f8f9fa;
  }
  
  </style>
  